import { Grid } from '../Grid';
import { Label } from '../Label';
import { MessageBlock } from '../MessageBlock';
import { clsx } from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const InputLayout = props => {
  const {
    layout,
    size,
    validationState,
    disabled,
    readOnly,
    displayLabel,
    children,
    required,
    labelClassName,
    labelId,
    label,
    messageId
  } = props;
  const labelCols = layout !== 'horizontal' ? 12 : 4;
  const containerCols = layout !== 'horizontal' ? 12 : 8;
  const messagePrefix = layout !== 'horizontal' ? 0 : 4;
  const messageCols = layout !== 'horizontal' ? 12 : 8;
  return /*#__PURE__*/_jsxs(Grid, {
    container: true,
    rowSpacing: '4px',
    className: clsx([`ids-input-layout-${layout}`]),
    id: 'ids-input-layout-grid-container',
    children: [displayLabel && /*#__PURE__*/_jsx(Grid, {
      xs: labelCols,
      display: 'flex',
      children: /*#__PURE__*/_jsx(Label, {
        className: labelClassName || 'ids-input-component-label',
        required: required,
        label: label,
        size: size,
        displayLabel: displayLabel,
        id: labelId || 'ids-input-component-label-id',
        layout: layout
      })
    }), /*#__PURE__*/_jsx(Grid, {
      xs: containerCols,
      children: children
    }), layout === 'horizontal' && !readOnly && /*#__PURE__*/_jsx(Grid, {
      xs: 4,
      className: 'ids-input-layout-message-spacer'
    }), !readOnly && /*#__PURE__*/_jsx(Grid, {
      xs: messageCols,
      children: /*#__PURE__*/_jsx(MessageBlock, {
        type: disabled || readOnly ? undefined : validationState?.type,
        message: disabled || readOnly ? undefined : validationState?.message,
        id: messageId,
        size: size
      })
    })]
  });
};